import { cn } from '@commenda/utils';
import React from 'react';

import { DataGridAlign } from '../types';
import { getDataGridJustifyClass, getDataGridTextAlignClass } from '../utils';

export interface DataGridCellTextProps
  extends React.HTMLAttributes<HTMLDivElement> {
  align?: DataGridAlign;
  isEmpty?: boolean;
  emptyText?: React.ReactNode;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
}

const DataGridCellText = React.forwardRef<HTMLDivElement, DataGridCellTextProps>(
  (
    {
      align = 'right',
      isEmpty = false,
      emptyText,
      leading,
      trailing,
      className,
      children,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      className={cn(
        'flex w-full items-center gap-lg',
        getDataGridJustifyClass(align),
        className
      )}
      {...props}
    >
      {leading}
      <span
        className={cn(
          'txt-small-regular min-w-0 truncate',
          isEmpty ? 'text-text-disabled' : 'text-text-primary',
          getDataGridTextAlignClass(align)
        )}
      >
        {isEmpty ? emptyText : children}
      </span>
      {trailing}
    </div>
  )
);

DataGridCellText.displayName = 'DataGridCellText';

export { DataGridCellText };
